<template>
	<span class="catchment-trend-cell">
		<v-icon v-if="direction === 'up'" class="catchment-trend-cell__icon catchment-trend-cell__icon--up">trending_up</v-icon>
		<v-icon v-else-if="direction === 'down'" class="catchment-trend-cell__icon catchment-trend-cell__icon--down">trending_down</v-icon>
		{{ formattedValue }}
	</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	params: { type: Object, required: true },
});

const direction = computed(() => props.params?.trend ?? null);

const formattedValue = computed(() => {
	const value = props.params?.value;
	if (value == null) return '—';
	const decimals = props.params?.decimals ?? 0;
	return Number(value).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
});
</script>

<style lang="scss">
.catchment-trend-cell {
	display: inline-flex;
	align-items: center;
	gap: 2px;

	&__icon {
		font-size: 16px;

		&--up {
			color: #2e7d32;
		}

		&--down {
			color: #c62828;
		}
	}
}
</style>
